export const SO_STATUS = {
  draft: { label: "Taslak", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  approved: { label: "Onaylandı", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  partial: { label: "Kısmi Teslim", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  completed: { label: "Tamamlandı", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  cancelled: { label: "İptal", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const SO_STOCK = {
  sufficient: { label: "Yeterli", dot: "bg-emerald-500" },
  partial: { label: "Kısmi / Eksik", dot: "bg-amber-400" },
  none: { label: "Stok Yok", dot: "bg-rose-500" },
};

export const SO_SOURCES = ["MANUAL", "TELEGRAM", "EMAIL", "ERP"];
export const SOURCE_LABEL = { MANUAL: "Manuel", TELEGRAM: "Telegram", EMAIL: "E-posta", ERP: "ERP" };

export const PRICE_FIELD = { bayi: "price_bayi", nokta: "price_nokta", nihai_tuketici: "price_nihai_tuketici", internet: "price_internet" };

export function freeFromMf(qty, mf) {
  const m = /^\s*(\d+)\s*\/\s*(\d+)\s*$/.exec(mf || "");
  if (!m || +m[1] <= 0) return 0;
  return Math.floor((Number(qty) || 0) / +m[1]) * +m[2];
}

const r2 = (x) => Math.round((x + Number.EPSILON) * 100) / 100;

// Mirrors backend _build for live preview; backend is the source of truth.
export function calcLine(ln) {
  const qty = Number(ln.qty) || 0;
  const unit = Number(ln.unit_price) || 0;
  const disc = Number(ln.discount_pct) || 0;
  const vat = Number(ln.vat_pct) || 0;
  const gross = r2(qty * unit);
  const discount = r2((gross * disc) / 100);
  const net = r2(gross - discount);
  const vatAmt = r2((net * vat) / 100);
  return { gross, discount, net, vat: vatAmt, total: r2(net + vatAmt), physical: qty + (Number(ln.free_qty) || 0) };
}

export function calcTotals(lines) {
  return lines.map(calcLine).reduce((a, c) => ({
    gross: r2(a.gross + c.gross), discount: r2(a.discount + c.discount), net: r2(a.net + c.net),
    vat: r2(a.vat + c.vat), grand_total: r2(a.grand_total + c.total),
  }), { gross: 0, discount: 0, net: 0, vat: 0, grand_total: 0 });
}

export const trDate = (iso) => (iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}` : "—");
